<template>
  <div class="not-found">
    <h1 class="title site-title">Page not found</h1>
    <button class="btn red_btn" @click="$router.push('/')">Return home</button>
  </div>
</template>

<script src="./not-found.ts"></script>
<style src="./not-found.scss" lang="scss"></style>
